import { render, staticRenderFns } from "./PartyRouterLinks.vue?vue&type=template&id=087536c6"
import script from "./PartyRouterLinks.vue?vue&type=script&lang=js"
export * from "./PartyRouterLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports